var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatewayLoginRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 777.55017,
    height: 520.5603,
    viewBox: "0 0 777.55017 520.56031",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-1782.4498,-919.43972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m -408.43359,1629.0924 -0.002,384.1676 -430.42925,-141.538 -1.658,-0.545 c -25.396,-8.318 -49.177,-22.806 -68.948,-43.459 -17.487,-18.267 -29.999,-39.464 -37.648,-61.922 -2.027,-5.951 -3.745,-11.983 -5.084,-18.082 l -33.34818,-118.618 z",
    style: {
      display: "inline",
      fill: "#ebeced",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    clipPath: "none",
    transform: "matrix(1.3333333,0,0,-1.3333333,3104.5781,3612.1231)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m -150.4434,1576.0449 0.006,273.7367 -304.53926,-43.8976 -1.568,-0.226 c -24.02,-3.434 -47.569,-12.638 -68.504,-27.989 -18.515,-13.576 -33.045,-30.557 -43.425,-49.432 -2.751,-5.002 -5.238,-10.124 -7.397,-15.367 l -65.85652,-136.8226 z",
    style: {
      display: "inline",
      fill: "#00426a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2760.5912,3541.3932)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayLoginRight);
export default __webpack_public_path__ + "static/media/gateway-login-right.4e897bcdb9210f90df41baa53b00f4d4.svg";
export { ForwardRef as ReactComponent };